import React, { FC, useEffect, useState } from 'react';
import { Switch } from 'antd';
import { InfiniteScroll } from 'common/components';
import { AuthHooks, UserHooks } from 'common/hooks';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { selectCurrentUser, updateUser } from 'entities/User/User.slice';

export const ProfileSettings: FC = () => {
  const dispatch = useAppDispatch();
  // user
  const currentUser = useAppSelector(selectCurrentUser);

  const [notificationsEnabled, setNotificationsEnabled] = useState<boolean>(false);
  const [inventoryActionNotificationsEnabled, setInventoryActionNotificationsEnabled] = useState<boolean>(false);
  const { isSeller } = AuthHooks.useIsSeller();
  const { isSellerManager, isManager } = UserHooks.useCurrentUserRole();

  useEffect(() => {
    if (currentUser) {
      setNotificationsEnabled(currentUser.notificationsEnabled);
      setInventoryActionNotificationsEnabled(currentUser.inventoryActionNotificationsEnabled);
    }
  }, [currentUser]);

  const handleChangeNotificationsEnabled = (value: boolean) => {
    setNotificationsEnabled(value);

    if (currentUser) {
      dispatch(updateUser({ id: currentUser.id, notificationsEnabled: value }));
    }
  };

  const handleChangeInventoryActionNotificationsEnabled = (value: boolean) => {
    setInventoryActionNotificationsEnabled(value);

    if (currentUser) {
      dispatch(
        updateUser({
          id: currentUser.id,
          inventoryActionNotificationsEnabled: value,
        }),
      );
    }
  };

  return (
    <div className="h-full flex direction-columns flex-1 profile__settings">
      <InfiniteScroll>
        <div className="mb-11 ff-regular fs-xxl">Настройки</div>

        <div className="mb-19 flex direction-column">
          <div className="mb-6 ff-regular fs-l">Уведомления на электронную почту</div>

          {(isManager || isSellerManager) && (
            <div className="mb-6 flex direction-column">
              <div className="mb-2 flex align-center justify-between">
                <span className="ff-regular fs-m">Заказы</span>

                <div className="ml-4">
                  <Switch checked={notificationsEnabled} onChange={handleChangeNotificationsEnabled} />
                </div>
              </div>

              <span className="ff-regular fs-xs color-dark-grey">Ежедневная рассылка о новых поступивших заказах</span>
            </div>
          )}

          {!isSeller && (
            <div className="flex direction-column">
              <div className="mb-2 flex align-center justify-between">
                <span className="ff-regular fs-m">Система учёта</span>

                <div className="ml-4">
                  <Switch
                    checked={inventoryActionNotificationsEnabled}
                    onChange={handleChangeInventoryActionNotificationsEnabled}
                  />
                </div>
              </div>

              <span className="ff-regular fs-xs color-dark-grey">
                Рассылка о новых входящих запросах на передачу и списание инструментов
              </span>
            </div>
          )}
        </div>
      </InfiniteScroll>
    </div>
  );
};
